module.exports = __webpack_public_path__ + "img/bioshock (2).13195f3c.jpg";